module.exports = __webpack_public_path__ + "static/media/Call_Assignment_English.2022e19b.svg";